import { render, staticRenderFns } from "./offerDialog.vue?vue&type=template&id=10bf066e&scoped=true&"
import script from "./offerDialog.vue?vue&type=script&lang=js&"
export * from "./offerDialog.vue?vue&type=script&lang=js&"
import style0 from "./offerDialog.vue?vue&type=style&index=0&id=10bf066e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf066e",
  null
  
)

export default component.exports